"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var iconLibrary = {
  circulartiendas: "icon-circular-tiendas",
  circularagenda: "icon-circular-agenda",
  circularchat: "icon-circular-chat",
  circularconectar: "icon-circular-conectar",
  circularcomunidad: "icon-circular-comunidad",
  circularescribenos: "icon-circular-escribenos",
  circularfactura: "icon-circular-factura",
  circularguru: "icon-circular-guru",
  circularlineas: "icon-circular-lineas",
  circularreclamacion: "icon-circular-reclamacion",
  circularsoportetecnico: "icon-circular-soporte-tecnico",
  gplus: "icon-gplus",
  facebook: "icon-facebook",
  tuenti: "icon-tuenti",
  youtube: "icon-youtube",
  rss: "icon-rss",
  flechadcha2: "icon-flecha-dcha-2",
  vdown: "icon-v-down",
  flechaoblicua: "icon-flecha-oblicua",
  plus: "icon-plus",
  plusforte: "icon-plus-forte",
  tiendas: "icon-tiendas",
  testvelocidad: "icon-test-velocidad",
  mimovistar: "icon-mi-movistar",
  porser: "icon-por-ser",
  soportetecnico: "icon-soporte-tecnico",
  manoslibres: "icon-manos-libres",
  lineas: "icon-lineas",
  gestionservicios: "icon-gestion-servicios",
  escribenos: "icon-escribenos",
  comunidad: "icon-comunidad",
  contactanos: "icon-contactanos",
  directorio: "icon-directorio",
  coberturaproducto: "icon-cobertura-producto",
  cobertura: "icon-cobertura",
  appmimovistar: "icon-app-mi-movistar",
  atencioncliente: "icon-atencion-cliente",
  movilesprepago: "icon-moviles-prepago",
  movilescontrato: "icon-moviles-contrato",
  icon3g: "icon-3g",
  aplicaciones: "icon-aplicaciones",
  asistenciatecnica: "icon-asistencia-tecnica",
  exclusivoonline: "icon-exclusivo-online",
  movilcontrato: "icon-movil-contrato",
  circular3g: "icon-circular-3g",
  circular4g: "icon-circular-4g",
  circularaplicaciones: "icon-circular-aplicaciones",
  circularfibra: "icon-circular-fibra",
  circularexclusivoonline: "icon-circular-exclusivo-online",
  circularmovilcontrato: "icon-circular-movil-contrato",
  circularmoviltarjeta: "icon-circular-movil-tarjeta",
  circularofertas: "icon-circular-ofertas",
  circulartvhd: "icon-circular-tv-hd",
  circularsms: "icon-circular-sms",
  circulardescargar: "icon-circular-descargar",
  circularflechadown: "icon-circular-flecha-down",
  reclamaciones: "icon-reclamaciones",
  circularlinkedin: "icon-circular-linkedin",
  enlacecircularempresas: "icon-enlace-circular-empresas",
  movilescontratoizq: "icon-moviles-contrato-izq",
  movilesprepagoizq: "icon-moviles-prepago-izq",
  linkedin: "icon-linkedin",
  favoritospartido: "icon-favoritos-partido",
  circulardatos: "icon-circular-datos",
  circularoficina: "icon-circular-oficina",
  circularproductividad: "icon-circular-productividad",
  accesible: "icon-accesible",
  adaptable: "icon-adaptable",
  apple: "icon-apple",
  audiencia: "icon-audiencia",
  datos: "icon-datos",
  calidad: "icon-calidad",
  escritorio: "icon-escritorio",
  identidad: "icon-identidad",
  innovacion: "icon-innovacion",
  ipad: "icon-ipad",
  iphone: "icon-iphone",
  lineasadicionales: "icon-lineas-adicionales",
  oficina: "icon-oficina",
  organizador: "icon-organizador",
  pc: "icon-pc",
  portatil: "icon-portatil",
  productividad: "icon-productividad",
  red: "icon-red",
  registrar: "icon-registrar",
  seguridadpc: "icon-seguridad-pc",
  servicios: "icon-servicios",
  smartphone: "icon-smartphone",
  tablet: "icon-tablet",
  tarifa: "icon-tarifa",
  tiempo: "icon-tiempo",
  windows: "icon-windows",
  circularaccesible: "icon-circular-accesible",
  circularadaptable: "icon-circular-adaptable",
  circularahorro: "icon-circular-ahorro",
  circularapple: "icon-circular-apple",
  circularaudiencia: "icon-circular-audiencia",
  circularbuscador: "icon-circular-buscador",
  circularbuscar: "icon-circular-buscar",
  circularcalidad: "icon-circular-calidad",
  circularcontrol: "icon-circular-control",
  circularglobal: "icon-circular-global",
  circulargplus: "icon-circular-g-plus",
  circulargarantia: "icon-circular-garantia",
  circularpc: "icon-circular-pc",
  circularfirefox: "icon-circular-firefox",
  circularfinanzas: "icon-circular-finanzas",
  circularfavoritos: "icon-circular-favoritos",
  circularfacebook: "icon-circular-facebook",
  circulareuro: "icon-circular-euro",
  circularescritorio: "icon-circular-escritorio",
  circularecologico: "icon-circular-ecologico",
  circulardatos1: "icon-circular-datos-1",
  circularidentidad: "icon-circular-identidad",
  circularinnovacion: "icon-circular-innovacion",
  circularinstagram: "icon-circular-instagram",
  circularipad: "icon-circular-ipad",
  circulariphone: "icon-circular-iphone",
  circularlineasadicionales: "icon-circular-lineas-adicionales",
  circularlinkedin1: "icon-circular-linkedin-1",
  circularmultipantalla: "icon-circular-multipantalla",
  circularportatil: "icon-circular-portatil",
  circularred: "icon-circular-red",
  circularregistrar: "icon-circular-registrar",
  circularrss: "icon-circular-rss",
  circularseguridadpc: "icon-circular-seguridad-pc",
  circularservicios: "icon-circular-servicios",
  circularsmartphone: "icon-circular-smartphone",
  circularsubir: "icon-circular-subir",
  circulartablet: "icon-circular-tablet",
  circulartarifa: "icon-circular-tarifa",
  circulartiempo: "icon-circular-tiempo",
  circulartuenti: "icon-circular-tuenti",
  circulartwitter: "icon-circular-twitter",
  circularwindows: "icon-circular-windows",
  circularyoutube: "icon-circular-youtube",
  fusionfibra: "icon-fusion-fibra",
  fusionfibra1: "icon-fusion-fibra-1",
  guru: "icon-guru",
  modemusbpartido: "icon-modem-usb-partido",
  eliminar: "icon-eliminar",
  viajar: "icon-viajar",
  musica: "icon-musica",
  preguntasfrecuentes: "icon-preguntas-frecuentes",
  circularnoticias: "icon-circular-noticias",
  videoclub: "icon-videoclub",
  infantil: "icon-infantil",
  documentales: "icon-documentales",
  circularpreguntasfrecuentes: "icon-circular-preguntas-frecuentes",
  circularpeliculas: "icon-circular-peliculas",
  circularmusica: "icon-circular-musica",
  circularfutbol: "icon-circular-futbol",
  circularinfantil: "icon-circular-infantil",
  circulardeportes: "icon-circular-deportes",
  circularcalendario: "icon-circular-calendario",
  circularfamilia: "icon-circular-familia",
  familia: "icon-familia",
  circularconfiguracionmovil: "icon-circular-configuracion-movil",
  circularcomparar: "icon-circular-comparar",
  comparar: "icon-comparar",
  menos: "icon-menos",
  circularaplicateca: "icon-circular-aplicateca",
  twitternegativo4: "icon-4-twitter-negativo",
  twitternegativo3: "icon-3-twitter-negativo",
  twitter3: "icon-3-twitter",
  twitter2: "icon-2-twitter",
  twitternegativo2: "icon-2-twitter-negativo",
  twitternegativo1: "icon-1-twitter-negativo",
  twitter1: "icon-1-twitter",
  validacionmovil: "icon-validacion-movil",
  twittersiguenos: "icon-twitter-siguenos",
  enviar: "icon-enviar",
  cheuronizq: "icon-cheuron-izq",
  circularayuda: "icon-circular-ayuda",
  circularcompra: "icon-circular-compra",
  circulardvr: "icon-circular-dvr",
  circularfacturagrafico: "icon-circular-factura-grafico",
  circularicloud: "icon-circular-icloud",
  circularnewsletter: "icon-circular-newsletter",
  circularpreguntasfrecuentes1: "icon-circular-preguntas-frecuentes-1",
  circularrecarga: "icon-circular-recarga",
  circularvideoclub: "icon-circular-videoclub",
  circularwebmail: "icon-circular-webmail",
  circularmapa: "icon-circular-mapa",
  mapa: "icon-mapa",
  circularinformacion: "icon-circular-informacion",
  icloud: "icon-icloud",
  circularcamara: "icon-circular-camara",
  circularconectividad: "icon-circular-conectividad",
  circularmemoria: "icon-circular-memoria",
  circularprocesador: "icon-circular-procesador",
  circulartampantalla: "icon-circular-tam-pantalla",
  circularaudio: "icon-circular-audio",
  circularcheurondown: "icon-circular-cheuron-down",
  circularbluetooth: "icon-circular-bluetooth",
  circulargrabacion: "icon-circular-grabacion",
  circularmostradortienda: "icon-circular-mostrador-tienda",
  circularbateria: "icon-circular-bateria",
  desbloquear: "icon-desbloquear",
  regalo: "icon-regalo",
  circularregalo: "icon-circular-regalo",
  android: "icon-android",
  circularandroid: "icon-circular-android",
  circularcheuronizq: "icon-circular-cheuron-izq",
  circularcheuronup: "icon-circular-cheuron-up",
  flechaup: "icon-flecha-up",
  adultos: "icon-adultos",
  circularadultos: "icon-circular-adultos",
  canalescarta: "icon-canales-carta",
  circularapps: "icon-circular-apps",
  circularcanalescarta: "icon-circular-canales-carta",
  circularcontenidocarta: "icon-circular-contenido-carta",
  circularhd: "icon-circular-hd",
  circularguiatv: "icon-circular-guia-tv",
  circularmultipantallatv: "icon-circular-multipantalla-tv",
  circularpinparental: "icon-circular-pin-parental",
  circularprogramastv: "icon-circular-programas-tv",
  circularrestart: "icon-circular-restart",
  circularseries: "icon-circular-series",
  circularvo: "icon-circular-vo",
  circularvideoteca: "icon-circular-videoteca",
  pinparental: "icon-pin-parental",
  hd: "icon-hd",
  guiatv: "icon-guia-tv",
  programastv: "icon-programas-tv",
  restart: "icon-restart",
  vo: "icon-vo",
  videoteca: "icon-videoteca",
  movilesliberados: "icon-moviles-liberados",
  circularcobertura: "icon-circular-cobertura",
  circularenvios: "icon-circular-envios",
  circularpagomensual: "icon-circular-pago-mensual",
  circularmovilesliberados: "icon-circular-moviles-liberados",
  circulartestvelocidad: "icon-circular-test-velocidad",
  guiarap: "icon-guia-rap",
  guiarap2: "icon-guia-rap-2",
  folleto: "icon-folleto",
  extenderpantalla: "icon-extender-pantalla",
  folleto1: "icon-folleto-1",
  reducirpantalla: "icon-reducir-pantalla",
  volumenon: "icon-volumen-on",
  volumenoff: "icon-volumen-off",
  volumenoff1: "icon-volumen-off-1",
  accesoclientes: "icon-acceso-clientes",
  circularasistenciatecnica: "icon-circular-asistencia-tecnica",
  apps: "icon-apps",
  envios: "icon-envios",
  pagomensual: "icon-pago-mensual",
  volumenon1: "icon-volumen-on-1",
  circularcheurondcha: "icon-circular-cheuron-dcha",
  paygo: "icon-pay-go",
  circularpaygo: "icon-circular-pay-go",
  circularjuegos: "icon-circular-juegos",
  juegos: "icon-juegos",
  twitter: "icon-twitter",
  testvelocidad100: "icon-test-velocidad-100",
  circulartestvelocidad100: "icon-circular-test-velocidad-100",
  circularpausa: "icon-circular-pausa",
  pausa: "icon-pausa",
  recarga: "icon-recarga",
  circularmoviltarjeta4: "icon-circular-movil-tarjeta-4",
  circularmoviltarjeta8: "icon-circular-movil-tarjeta-8",
  circulramoviltarjeta2: "icon-circulra-movil-tarjeta-2",
  moviltarjeta: "icon-movil-tarjeta",
  moviltarjeta2: "icon-movil-tarjeta-2",
  moviltarjeta4: "icon-movil-tarjeta-4",
  moviltarjeta8: "icon-movil-tarjeta-8",
  circularmoviltarjeta6: "icon-circular-movil-tarjeta-6",
  moviltarjeta6: "icon-movil-tarjeta-6",
  aplicateca: "icon-aplicateca",
  circularred1: "icon-circular-red-1",
  red2: "icon-red2",
  circularaccesoclientes: "icon-circular-acceso-clientes",
  circulardesvio: "icon-circular-desvio",
  desvio: "icon-desvio",
  circularcomunidadprofesional: "icon-circular-comunidad-profesional",
  comunidadprofesional: "icon-comunidad-profesional",
  wifiplus: "icon-wifi-plus",
  wifiplus1: "icon-wifi-plus-1",
  testvelocidad300: "icon-test-velocidad-300",
  circularmanualinteractivo: "icon-circular-manual-interactivo",
  manualinteractivo: "icon-manual-interactivo",
  circularflag: "icon-circular-flag",
  flag: "icon-flag",
  circularfacturainteractiva: "icon-circular-factura-interactiva",
  facturainteractiva: "icon-factura-interactiva",
  circularbuscar2: "icon-circular-buscar-2",
  circularmosaico: "icon-circular-mosaico",
  reparacionmoviles: "icon-reparacion-moviles",
  cazaypesca: "icon-cazaypesca",
  sininversion: "icon-sin-inversion",
  semi: "icon-semi",
  latino: "icon-latino",
  configuracionmovil: "icon-configuracion-movil",
  twitter4: "icon-4-twitter",
  mando: "icon-mando",
  multipantalla: "icon-multipantalla",
  ofimatica: "icon-ofimatica",
  opciones: "icon-opciones",
  circulardolbydigital: "icon-circular-dolbydigital",
  dolbydigital: "icon-dolbydigital",
  control: "icon-control",
  circularmultisim: "icon-circular-multisim",
  multisim: "icon-multisim",
  multipantallatv: "icon-multipantalla-tv",
  circular4gplus: "icon-circular-4g-plus",
  gplus4: "icon-4g-plus",
  estrella1: "icon-estrella-1",
  estrella0: "icon-estrella-0",
  estrella2: "icon-estrella-2",
  tabletmovil: "icon-tablet-movil",
  televisor: "icon-televisor",
  toggleoff: "icon-toggle-off",
  androidvolumedown: "icon-android-volume-down",
  comparativaoff: "icon-comparativa-off",
  comparativaon: "icon-comparativa-on",
  corazonoff: "icon-corazon-off",
  corazonon: "icon-corazon-on",
  firefox: "icon-firefox",
  iexplorer: "icon-i-explorer",
  opera: "icon-opera",
  ordenfilas: "icon-orden-filas",
  ordenmodular: "icon-orden-modular",
  safari: "icon-safari",
  chrome: "icon-chrome",
  circularajustes: "icon-circular-ajustes",
  circularpinchaaqui: "icon-circular-pincha-aqui",
  pinchaaqui: "icon-pincha-aqui",
  medir: "icon-medir",
  ok: "icon-ok",
  ram1gb: "icon-ram-1gb",
  ram2gb: "icon-ram-2gb",
  ram3gb: "icon-ram-3gb",
  ram4gb: "icon-ram-4gb",
  circularmedir: "icon-circular-medir",
  circularok: "icon-circular-ok",
  circularx: "icon-circular-x",
  circularram1gb: "icon-circular-ram-1gb",
  circularram2gb: "icon-circular-ram-2gb",
  circularram3gb: "icon-circular-ram-3gb",
  circularram4gb: "icon-circular-ram-4gb",
  circularautoayuda: "icon-circular-autoayuda",
  autoayuda: "icon-autoayuda",
  pagotv: "icon-pago-tv",
  circularaaplicaciones: "icon-circular-a-aplicaciones",
  circulartarifamovil: "icon-circular-tarifa-movil",
  circulartvalacarta: "icon-circular-tv-a-la-carta",
  tarifainternacional: "icon-tarifa-internacional",
  tarifamovil: "icon-tarifa-movil",
  tarifasroaming: "icon-tarifas-roaming",
  circularalerta: "icon-circular-alerta",
  extenderpantalla1: "icon-extender-pantalla-1",
  circularreducirpantalla: "icon-circular-reducir-pantalla",
  recarga1: "icon-recarga-1",
  volumenon2: "icon-volumen-on-2",
  volumenoff2: "icon-volumen-off-2",
  circularseguridad: "icon-circular-seguridad",
  activarlineamovil: "icon-activar-linea-movil",
  campana: "icon-campana",
  champions: "icon-champions",
  coparey: "icon-copa-rey",
  traficodatos: "icon-trafico-datos",
  circularvolumen: "icon-circular-volumen",
  circularcargador: "icon-circular-cargador",
  circularcabledatos: "icon-circular-cable-datos",
  circularplusforte: "icon-circular-plus-forte",
  grabacion: "icon-grabacion",
  europaleague: "icon-europa-league",
  lineas2: "icon-lineas2",
  vod: "icon-vod",
  mosaico: "icon-mosaico",
  aaplicaciones: "icon-a-aplicaciones",
  cabledatos: "icon-cable-datos",
  guardar: "icon-guardar",
  circularguardar: "icon-circular-guardar",
  circularver: "icon-circular-ver",
  mpluscircu: "icon-mpluscircu",
  multidispositivotv: "icon-multidispositivo-tv",
  circularoficinamovil: "icon-circular-oficina-movil",
  oficinamovil: "icon-oficina-movil",
  circularimprimir: "icon-circular-imprimir",
  imprimir: "icon-imprimir",
  fibra50: "icon-fibra-50",
  fibrasimetrica: "icon-fibra-simetrica",
  mejorar: "icon-mejorar",
  circularconsultarconsumos: "icon-circular-consultar-consumos",
  conectividad: "icon-conectividad",
  circulardescarga2: "icon-circular-descarga2",
  circularmotor: "icon-circular-motor",
  circularproducto: "icon-circular-producto",
  nota: "icon-nota",
  menuopciones: "icon-menu-opciones",
  infinity: "icon-infinity",
  nover: "icon-no-ver",
  audicionnulacuadrado: "icon-audicion-nula-cuadrado",
  audicionparcialcuadrado: "icon-audicion-parcial-cuadrado",
  dificultadcomprensioncuadrado: "icon-dificultad-comprension-cuadrado",
  dificultadmoderadamanipulacioncuadrado: "icon-dificultad-moderada-manipulacion-cuadrado",
  dificultadseveramanipulacioncuadrado: "icon-dificultad-severa-manipulacion-cuadrado",
  visionnulacuadrado: "icon-vision-nula-cuadrado",
  visionparcialcuadrado: "icon-vision-parcial-cuadrado",
  locklockerstreamline: "icon-lock-locker-streamline",
  streamlinesync: "icon-streamline-sync",
  comunidadnuevo: "icon-comunidad-nuevo",
  configuracionnuevo: "icon-configuracion-nuevo",
  gestionnuevo: "icon-gestion-nuevo",
  ideanuevo: "icon-idea-nuevo",
  maletinnuevo: "icon-maletin-nuevo",
  fusion4tvmob2ficcion: "icon-fusion4tvmob2-ficcion",
  mnuevo: "icon-m-nuevo",
  circularecorating: "icon-circular-ecorating",
  contenedornube: "icon-contenedor-nube",
  contenedorboca: "icon-contenedor-boca",
  contenedorpoligono: "icon-contenedor-poligono",
  contenedorgota: "icon-contenedor-gota",
  contenedorestrella: "icon-contenedor-estrella",
  contenedorcorazon: "icon-contenedor-corazon",
  contenedorbocadillo: "icon-contenedor-bocadillo",
  tarjeta: "icon-tarjeta",
  contenedorpoligono1: "icon-contenedor-poligono-1",
  contenedor1: "icon-contenedor-1",
  contenedor2: "icon-contenedor-2",
  contenedor3: "icon-contenedor-3",
  contenedor4: "icon-contenedor-4",
  contenedor5: "icon-contenedor-5",
  nbigote: "icon-n-bigote",
  nbluetooh: "icon-n-bluetooh",
  ncine: "icon-n-cine",
  ncopa: "icon-n-copa",
  ndownload: "icon-n-download",
  nphone: "icon-n-phone",
  nportatil: "icon-n-portatil",
  ntablet: "icon-n-tablet",
  ntv: "icon-n-tv",
  nsol: "icon-n-sol",
  npeople: "icon-n-people",
  nhd: "icon-n-hd",
  ntvico: "icon-n-tv-ico",
  bocadillos: "icon-bocadillos",
  bombilla: "icon-bombilla",
  llave: "icon-llave",
  movistar: "icon-movistar",
  rueda: "icon-rueda",
  circulartarjeta: "icon-circular-tarjeta",
  velocidad: "icon-velocidad",
  classica: "icon-classica",
  barcatv: "icon-barcatv",
  cazapesca: "icon-caza-pesca",
  iberalia: "icon-iberalia",
  mezzotv: "icon-mezzotv",
  playboy: "icon-playboy",
  off2: "icon-off-2",
  desconectar: "icon-desconectar",
  instagram: "icon-instagram",
  circularinternetmovil: "icon-circular-internet-movil",
  internetyfijo: "icon-internet-y-fijo",
  fusion4tvmob2: "icon-fusion4tvmob2",
  fusion4tvmob4: "icon-fusion4tvmob4",
  punteadomovilnuevo: "icon-punteado-movil-nuevo",
  movil2: "icon-movil2",
  movil4: "icon-movil4",
  lanzarver: "icon-lanzar-ver",
  circularatencionsoporte: "icon-circular-atencion-soporte",
  centralitavirtual: "icon-centralita-virtual",
  circularconfiguracion: "icon-circular-configuracion",
  circularflechasizquierda: "icon-circular-flechas-izquierda",
  circularetiqueta: "icon-circular-etiqueta",
  etiqueta: "icon-etiqueta",
  flechasizquierda: "icon-flechas-izquierda",
  cerradonuevo: "icon-cerrado-nuevo",
  express: "icon-express",
  ofertanuevo: "icon-oferta-nuevo",
  restartnuevo: "icon-restart-nuevo",
  velocidadmax: "icon-velocidad-max",
  circulardinamismo: "icon-circular-dinamismo",
  circularflexibilidad: "icon-circular-flexibilidad",
  check: "icon-check",
  m: "icon-m",
  catalogo: "icon-catalogo",
  palomitas: "icon-palomitas",
  pantallatactil: "icon-pantalla-tactil",
  tenis: "icon-tenis",
  menu: "icon-menu",
  circulargarantianegativo: "icon-circular-garantia-negativo",
  guiarap1: "icon-guia-rap-1",
  cheurondcha1: "icon-cheuron-dcha-1",
  robot: "icon-robot",
  dispositivosconectados: "icon-dispositivos-conectados",
  facil: "icon-facil",
  global: "icon-global",
  ahorro: "icon-ahorro",
  conectar: "icon-conectar",
  fusion2: "icon-fusion2",
  producto: "icon-producto",
  fusion4tv: "icon-fusion4tv",
  copanew: "icon-copa-new",
  atclienteayuda: "icon-at-cliente-ayuda",
  chattecnico: "icon-chat-tecnico",
  apretonmanos: "icon-apreton-manos",
  cheurondcha: "icon-cheuron-dcha",
  robomovil: "icon-robo-movil",
  editar: "icon-editar",
  configurarrouter: "icon-configurar-router",
  hora: "icon-hora",
  nmultidispositivo: "icon-n-multidispositivo",
  ngamepad1: "icon-n-gamepad-1",
  nmultidispositivo1: "icon-n-multidispositivo-1",
  consultarconsumos: "icon-consultar-consumos",
  recarganuevo: "icon-recarga-nuevo",
  aura: "icon-aura",
  like: "icon-like",
  dislike: "icon-dislike",
  circulardislike: "icon-circular-dislike",
  circularlike: "icon-circular-like",
  circularvideoconferencia: "icon-circular-videoconferencia",
  ncandado: "icon-n-candado",
  circularplay: "icon-circular-play",
  play: "icon-play",
  circulardocumentales: "icon-circular-documentales",
  familiar: "icon-familiar",
  multiacceso: "icon-multiacceso",
  cloudnuevo: "icon-cloud-nuevo",
  circularmultiacceso: "icon-circular-multiacceso",
  mapanuevo: "icon-mapa-nuevo",
  icon1: "icon-1",
  multicontenidosolid: "icon-multicontenido-solid",
  multicontenido: "icon-multicontenido",
  multicontenidomedium: "icon-multicontenido-medium",
  tv: "icon-tv",
  tvmedium: "icon-tv-medium",
  tvsolid: "icon-tv-solid",
  blog: "icon-blog",
  blogmedium: "icon-blog-medium",
  blogsolid: "icon-blog-solid",
  compartir: "icon-compartir",
  compartirmedium: "icon-compartir-medium",
  compartirsolid: "icon-compartir-solid",
  consultacanjes: "icon-consulta-canjes",
  consultacanjesmedium: "icon-consulta-canjes-medium",
  consultacanjessolid: "icon-consulta-canjes-solid",
  dinero: "icon-dinero",
  dineromedium: "icon-dinero-medium",
  dinerosolid: "icon-dinero-solid",
  filterandroid: "icon-filter-android",
  lanzamiento: "icon-lanzamiento",
  lanzamientomedium: "icon-lanzamiento-medium",
  lanzamientosolid: "icon-lanzamiento-solid",
  mobileconnect: "icon-mobile-connect",
  fibrasolid: "icon-fibra-solid",
  fibramedium: "icon-fibra-medium",
  fibra: "icon-fibra",
  fibranuevo: "icon-fibra-nuevo",
  abiertosolid: "icon-abierto-solid",
  mundo: "icon-mundo",
  mundosolid: "icon-mundo-solid",
  ofertas: "icon-ofertas",
  ofertasmedium: "icon-ofertas-medium",
  ofertassolid: "icon-ofertas-solid",
  router: "icon-router",
  routermedium: "icon-router-medium",
  routersolid: "icon-router-solid",
  tvnuevo: "icon-tv-nuevo",
  abierto: "icon-abierto",
  abiertomedium: "icon-abierto-medium",
  mundomedium: "icon-mundo-medium",
  configuracion: "icon-configuracion",
  configuracionmedium: "icon-configuracion-medium",
  configuracionsolid: "icon-configuracion-solid",
  movil: "icon-movil",
  movilmedium: "icon-movil-medium",
  movilsolid: "icon-movil-solid",
  internet: "icon-internet",
  internetmedium: "icon-internet-medium",
  internetsolid: "icon-internet-solid",
  circularinternet: "icon-circular-internet",
  circularmovil: "icon-circular-movil",
  circulartv: "icon-circular-tv",
  circularfusion: "icon-circular-fusion",
  circularfijo: "icon-circular-fijo",
  fijomedium: "icon-fijo-medium",
  fijo: "icon-fijo",
  movilnuevo: "icon-movil-nuevo",
  fijonuevo: "icon-fijo-nuevo",
  fijosolid: "icon-fijo-solid",
  tvuhd: "icon-tv-uhd",
  u7d: "icon-u7d",
  buscar: "icon-buscar",
  buscarsolid: "icon-buscar-solid",
  tvhd: "icon-tv-hd",
  buscarmobile: "icon-buscar-mobile",
  netflix: "icon-netflix",
  netflixmedium: "icon-netflix-medium",
  netflixsolid: "icon-netflix-solid",
  nube: "icon-nube",
  nubemedium: "icon-nube-medium",
  nubesolid: "icon-nube-solid",
  usuario: "icon-usuario",
  usuariomedium: "icon-usuario-medium",
  usuariosolid: "icon-usuario-solid",
  usuariologado: "icon-usuario-logado",
  usuarionuevo: "icon-usuario-nuevo",
  toros: "icon-toros",
  torosmedium: "icon-toros-medium",
  series: "icon-series",
  seriesmedium: "icon-series-medium",
  motor: "icon-motor",
  motormedium: "icon-motor-medium",
  megusta: "icon-me-gusta",
  megustamedium: "icon-me-gusta-medium",
  megustasolid: "icon-me-gusta-solid",
  futbol: "icon-futbol",
  futbolmedium: "icon-futbol-medium",
  deportes: "icon-deportes",
  deportesmedium: "icon-deportes-medium",
  cine: "icon-cine",
  cinemedium: "icon-cine-medium",
  callcenter: "icon-call-center",
  callcentermedium: "icon-call-center-medium",
  callcentersolid: "icon-call-center-solid",
  descargarmedium: "icon-descargar-medium",
  descargarsolid: "icon-descargar-solid",
  descargar: "icon-descargar",
  descargarnuevo: "icon-descargar-nuevo",
  descarga2: "icon-descarga2",
  sms: "icon-sms",
  smsmedium: "icon-sms-medium",
  smssolid: "icon-sms-solid",
  compra: "icon-compra",
  compramedium: "icon-compra-medium",
  comprasolid: "icon-compra-solid",
  chatsolid: "icon-chat-solid",
  chatmedium: "icon-chat-medium",
  chat: "icon-chat",
  chatnuevo: "icon-chat-nuevo",
  informacion: "icon-informacion",
  informacionmedium: "icon-informacion-medium",
  informacionsolid: "icon-informacion-solid",
  ecologico: "icon-ecologico",
  ecologicomedium: "icon-ecologico-medium",
  ecologicosolid: "icon-ecologico-solid",
  calendario: "icon-calendario",
  calendariomedium: "icon-calendario-medium",
  calendariosolid: "icon-calendario-solid",
  noticias: "icon-noticias",
  noticiasmedium: "icon-noticias-medium",
  noticiassolid: "icon-noticias-solid",
  peliculas: "icon-peliculas",
  garantia: "icon-garantia",
  agenda: "icon-agenda",
  agendamedium: "icon-agenda-medium",
  agendasolid: "icon-agenda-solid",
  favoritos: "icon-favoritos",
  favoritosmedium: "icon-favoritos-medium",
  favoritossolid: "icon-favoritos-solid",
  fusion: "icon-fusion",
  comprarcelularesmedium: "icon-comprar-celulares-medium",
  enviomedium: "icon-envio-medium",
  enviosolid: "icon-envio-solid",
  envio: "icon-envio",
  comprarcelularessolid: "icon-comprar-celulares-solid",
  comprarcelulares: "icon-comprar-celulares",
  perdidarobocelulares: "icon-perdida-robo-celulares",
  perdidarobocelularesmedium: "icon-perdida-robo-celulares-medium",
  perdidarobocelularessolid: "icon-perdida-robo-celulares-solid",
  configurarcelular: "icon-configurar-celular",
  configurarcelularmedium: "icon-configurar-celular-medium",
  configurarcelularsolid: "icon-configurar-celular-solid",
  clavewifi: "icon-clave-wifi",
  clavewifimedium: "icon-clave-wifi-medium",
  clavewifisolid: "icon-clave-wifi-solid",
  home: "icon-home",
  homemedium: "icon-home-medium",
  homesolid: "icon-home-solid",
  pagarfactura: "icon-pagar-factura",
  pagarfacturamedium: "icon-pagar-factura-medium",
  pagarfacturasolid: "icon-pagar-factura-solid",
  x: "icon-x",
  xmedium: "icon-x-medium",
  alerta: "icon-alerta",
  alertamedium: "icon-alerta-medium",
  alertasolid: "icon-alerta-solid",
  ajustes: "icon-ajustes",
  ajustesmedium: "icon-ajustes-medium",
  ajustessolid: "icon-ajustes-solid",
  ayuda: "icon-ayuda",
  ayudamedium: "icon-ayuda-medium",
  ayudasolid: "icon-ayuda-solid",
  documento: "icon-documento",
  documentomedium: "icon-documento-medium",
  documentosolid: "icon-documento-solid",
  factura: "icon-factura",
  facturamedium: "icon-factura-medium",
  facturasolid: "icon-factura-solid",
  filtro: "icon-filtro",
  filtromedium: "icon-filtro-medium",
  filtrosolid: "icon-filtro-solid",
  ver: "icon-ver",
  vermedium: "icon-ver-medium",
  versolid: "icon-ver-solid",
  seguridad: "icon-seguridad",
  seguridadmedium: "icon-seguridad-medium",
  seguridadsolid: "icon-seguridad-solid",
  canales80: "icon-80canales",
  canalesmedium80: "icon-80canales-medium",
  mastv: "icon-mastv",
  mastvmedium: "icon-mastv-medium",
  localizacion: "icon-localizacion",
  localizacionmedium: "icon-localizacion-medium",
  localizacionsolid: "icon-localizacion-solid",
  wifi: "icon-wifi",
  velocidadapp: "icon-velocidad-app",
  navegar: "icon-navegar",
  carsos: "icon-car-sos",
  cloudmedium: "icon-cloud-medium",
  cloudsolid: "icon-cloud-solid",
  cloud: "icon-cloud",
  internetmovil: "icon-internet-movil",
  icon4g: "icon-4g",
  circularenvio: "icon-circular-envio",
  icon4gmedium: "icon-4g-medium",
  buscarmedium: "icon-buscar-medium",
  buscarmobile404: "icon-buscar-mobile404",
  hgu: "icon-hgu",
  hgumedium: "icon-hgu-medium",
  hgusolid: "icon-hgu-solid",
  ont: "icon-ont",
  ontmedium: "icon-ont-medium",
  ontsolid: "icon-ont-solid",
  arrowleftright: "icon-arrow-left-right",
  arrowleftrightmedium: "icon-arrow-left-right-medium",
  arrowleftrightsolid: "icon-arrow-left-right-solid",
  ofertasexclusivassolid: "icon-ofertas-exclusivas-solid",
  ofertasexclusivasmedium: "icon-ofertas-exclusivas-medium",
  ofertasexclusivas: "icon-ofertas-exclusivas",
  desco: "icon-desco",
  descomedium: "icon-desco-medium",
  descosolid: "icon-desco-solid",
  descomando: "icon-descomando",
  descomandomedium: "icon-descomando-medium",
  descomandosolid: "icon-descomando-solid"
};
var _default = iconLibrary;
exports.default = _default;

//# sourceMappingURL=index.js.map